import type { IconSvgObject } from './types';

const CircleArrowMoveLeftDownIcon: IconSvgObject = [
  ["path", { d: "M14 16L13.9972 10.9994C13.9969 10.4474 13.5493 10 12.9972 10H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 7.99994L7.5 9.99994L9.5 11.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 14.5L14 16.5L12 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CircleArrowMoveLeftDownIcon;
